import {


  WarningPanel,
} from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';

import {
  ChipComponent as Chip,
  Table,
} from '@internal/plugin-components-react';
import { Button, Typography } from '@material-ui/core';

import React from 'react';
import { useParams } from 'react-router-dom';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import { accessControlApiRef } from '../../api/types';
import { getChipType } from '../GroupAccessPage/helper';

const chipStyle = {
  marginRight: 4,
};
const columns = [
  {
    title: 'Module',
    field: 'module',
    width: '20%',
    highlight: true,
    render: ({ module }) => (
      React.createElement(Typography, { variant: "subtitle2",}, module)
    ),
  },
  {
    title: 'Submodule',
    field: 'submodule',
    width: '30%',
    highlight: true,
    render: ({ submodule }) => (
      React.createElement(Typography, { variant: "subtitle2",}, submodule)
    ),
  },
  {
    title: 'Group',
    field: 'owner_id',
    width: '30%',
    highlight: true,
    render: ({ owner_id }) => {
      const groupName = owner_id.replace('group:', '');
      return React.createElement(Typography, { variant: "subtitle2",}, groupName);
    },
  },
  {
    title: 'Action',
    field: 'action',
    width: '20%',
    highlight: true,
    render: ({ action }) =>
      action.map(actionItem => (
        React.createElement(Chip, {
          label: actionItem,
          style: chipStyle,
          type: getChipType(actionItem),}
        )
      )),
  },
];
const filters = [
  {
    column: 'Module',
    type: 'select',
  },
  {
    column: 'Submodule',
    type: 'select',
  },
  {
    column: 'Group',
    type: 'select',
  },
  {
    column: 'Action',
    type: 'multiple-select',
  },
];
export default function UserAccessTable() {
  const { userId } = useParams();

  const accessControlApi = useApi(accessControlApiRef);

  const {
    value: userPermissions,
    retry: refetchUserPermissions,
    error: userPermissionsError,
  } = useAsyncRetry(
    async () => accessControlApi.getPermissionsByUser(userId),
    [],
  );

  if (userPermissionsError)
    return (
      React.createElement(WarningPanel, {
        severity: "error",
        title: "Fetching entity error"  ,
        message: "Oops! An error occurred while fetching user permissions, please reach out to our support team for help."                ,}
      
        , React.createElement(Button, {
          variant: "contained",
          color: "secondary",
          onClick: () => refetchUserPermissions(),}
        , "Retry"

        )
      )
    );

  return (
    React.createElement(Table, {
      options: {
        pageSize: 20,
      },
      filters: filters,
      columns: columns,
      data: userPermissions || [],}
    )
  );
}
